<template>
  <div class="referencias-lineas-investigacion">
    <div class="encabezado" :class="{'border-bottom-none': tieneVistaSimplificada}">
      <h2 class="subtitulo no-margin">{{ titulo }}</h2>
      <a class="btn ocultar-vista-simplificada" :href="descarga" target="_blank" rel="noopener noreferrer">
        Descargar lista
      </a>
    </div>
    <a class="btn-simplificado a11y-simplificada-block" :href="descarga" target="_blank" rel="noopener noreferrer">Descargar lista</a>
    <div class="contenedor-lista" :class="{'max-height-inherit': tieneVistaSimplificada}">
      <ul class="lista-referencias"
       v-for="(linea, idx) in lineas"
       :key="`lineas_${idx}`"
       >
        <li>{{linea[0].linea_investigacion}}</li>
        <ul class="">
          <li v-for="(cita, id) in linea" :key="`citas_${id}`">
            <!-- Guía de estilo de referencia APA
              https://apastyle.apa.org/style-grammar-guidelines/references/examples/
             -->
            <span v-if="cita.tipo_publicacion === 'Libro'">
              {{cita.autores}}
              ({{cita.anio_edicion}}).
              <i>{{cita.titulo_libro}}</i>.
              {{cita.editorial}}.
              <span v-if="cita.recurso_doi !== 'n.d.'"><a :href="cita.recurso_doi">{{cita.recurso_doi}}</a></span>
              <span v-else><a :href="cita.direccion_electronica">{{cita.direccion_electronica}}</a></span>
            </span>
            <span v-if="cita.tipo_publicacion === 'Articulo'">
              {{cita.autores}}
              ({{cita.anio_edicion}}).
              {{cita.titulo_articulo}}.
              <i>{{cita.revista}},</i>
              {{cita.vol_num}}, {{cita.paginas}}.
              <span v-if="cita.editorial">{{cita.editorial}}. </span>
              <span v-if="cita.recurso_doi !== 'n.d.' && cita.recurso_doi !== null"><a :href="cita.recurso_doi">{{cita.recurso_doi}}</a></span>
              <span v-else><a :href="cita.direccion_electronica">{{cita.direccion_electronica}}</a></span>
            </span>
            <span v-if="cita.tipo_publicacion === 'Sitio Web'">
              {{cita.autores}}
              ({{cita.anio_edicion}}, {{cita.mes_publicacion}}).
              <i>{{cita.titulo_pag_web}}</i>.
              {{cita.editorial}}.
              <span v-if="cita.recurso_doi !== 'n.d.' && cita.recurso_doi !== null"><a :href="cita.recurso_doi">{{cita.recurso_doi}}</a></span>
              <span v-else><a :href="cita.direccion_electronica">{{cita.direccion_electronica}}</a></span>
            </span>
          </li>
        </ul>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titulo: {
      type: String,
    },
    referencias: {
      type: Array,
      default: () => [],
    },
    descarga: {
      type: String,
    },
  },
  data(){
    return {
     lineas: [],
    }
  },
  mounted(){
    this.listaReferencias();
  },
  computed: {
    tieneVistaSimplificada(){
      return this.$store.getters.tieneVistaSimplificada;
    }
  },
  methods: {
    listaReferencias() {
      // creando un arreglo de las líneas de investigación
      const myArray = [];
      this.referencias.map(d => {
        myArray.push(d.linea_investigacion)
      })
      // obteniendo los valores únicos
      const unique = (arr) => [...new Set(arr)]
      this.unique = unique(myArray);
      // 
      this.unique.forEach(d => {
        this.linea = this.referencias.filter(dd => dd.linea_investigacion === d);
        this.lineas.push(this.linea);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.referencias-lineas-investigacion {
  .encabezado {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-bottom: 1px solid #505050;
    &.border-bottom-none {
      border-bottom: none;
    }
    @media (min-width: map-get($media-queries-limit, "mobile")) {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
    .no-margin {
      margin: 16px 0;
      font-size: 18px;
    }
    a.btn {
      height: 40px;
      max-width: 170px;
      padding: 10px 25px;
      margin-bottom: 16px;
      background-color: #9d4637;
    }
  }
  .btn-simplificado {
    width: fit-content;
    margin: 16px 0;
  }
  .contenedor-lista {
    word-wrap: anywhere;
    max-height: 400px;
    overflow-y: auto;
    scrollbar-width: thin;
    &.max-height-inherit {
      max-height: inherit;
    }
    &:hover {
      background: transparent;
    }
    @media (min-width: map-get($media-queries-limit, "mobile")) {
      &:hover {
        background: #F5F5F5;
      }      
    }
    .lista-referencias {
      > li {
        font-weight: 600;
      }      
      ul {
        margin: 0;
        padding-left: 8px;
        list-style: circle inside;
        li {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
